import { z } from 'zod/v3'
import { WorkspaceDataExportStatusSchema } from '../generated/enums'

export const WorkspaceDataExportWarningSchema = z.object({
  code: z.enum([
    'SOURCE_OBJECT_MISSING',
    'CONTENT_UNAVAILABLE',
    'FORMAT_FALLBACK',
  ]),
  sourceRef: z.string(),
  storageKeyHash: z.string().optional(),
  message: z.string(),
})

export const WorkspaceDataExportSchema = z.object({
  id: z.string(),
  status: WorkspaceDataExportStatusSchema,
  requestedBy: z.object({
    id: z.string(),
    name: z.string().nullable(),
    email: z.string(),
  }),
  generationStartedAt: z.date().nullable(),
  completedAt: z.date().nullable(),
  expiresAt: z.date().nullable(),
  fileName: z.string().nullable(),
  fileSizeBytes: z.string().nullable(),
  manifestHash: z.string().nullable(),
  warnings: z.array(WorkspaceDataExportWarningSchema),
  warningCount: z.number().int().nonnegative(),
  errorMessage: z.string().nullable(),
  createdAt: z.date(),
  updatedAt: z.date(),
})

export type WorkspaceDataExport = z.infer<typeof WorkspaceDataExportSchema>
export type WorkspaceDataExportWarning = z.infer<
  typeof WorkspaceDataExportWarningSchema
>

export const WorkspaceDataExportListSchema = z.object({
  items: z.array(WorkspaceDataExportSchema),
  nextCursor: z.string().nullable(),
})

export type WorkspaceDataExportList = z.infer<
  typeof WorkspaceDataExportListSchema
>
